// category — am. Canonical bazaar category display names.
// The KEY is the canonical English filter key stored in the database; the
// VALUE is what users read. Never translate the keys — products are matched
// against them.

export default {
  catHandmadeCrafts: 'በእጅ የተሠሩ ሥራዎች',
  catFashion: 'ልብስ',
  catFoodBeverage: 'ምግብ እና መጠጥ',
  catBeautyHealth: 'ውጤትና ጤና',
  catHomeLiving: 'ቤትና የቤት አካባቢ',
  catSportsOutdoors: 'ስፖርትና ውጭ አካባቢ',
  catBooksMedia: 'መጽሐፍና ሚዲያ',
  catServices: 'አገልግሎቶች',

  // Subcategory display names
  subPotteryCeramics: 'ሸክላና ሴራሚክስ',
  subWeavingTextiles: 'ሽመናና ጨርቃጨርቅ',
  subJewelryAccessories: 'ጌጣጌጥና መለዋወጫ',
  subLeatherGoods: 'የቆዳ ዕቃዎች',
  subWoodwork: 'የእንጨት ሥራ',
  subHomeDecor: 'የቤት ማስዋቢያ',
  subWomensClothing: 'የሴቶች ልብስ',
  subMensClothing: 'የወንዶች ልብስ',
  subChildrensClothing: 'የልጆች ልብስ',
  subShoesBags: 'ጫማና ቦርሳ',
  subTraditionalClothing: 'ባህላዊ ልብስ',
  subAccessories: 'መለዋወጫዎች',
  subCoffeeTea: 'ቡናና ሻይ',
  subSpicesGrains: 'ቅመምና እህል',
  subHoneySweets: 'ማርና ጣፋጮች',
  subTraditionalFood: 'ባህላዊ ምግብ',
  subColdDrinks: 'ቀዝቃዛ መጠጦች',
  subKitchenStaples: 'የኩሽና ተጠቃሚ ዕቃዎች',
  subSkincare: 'የቆዳ እንክብካቤ',
  subHaircare: 'የፀጉር እንክብካቤ',
  subPerfumeFragrance: 'ሽቶና ሽታ',
  subCosmetics: 'ኮስሜቲክስ',
  subWellnessSupplements: 'ጤናና ማሟያዎች',
  subNaturalRemedies: 'ተፈጥሯዊ ሕክምናዎች',
  subFurniture: 'የቤት ዕቃዎች',
  subKitchenDining: 'ኩሽናና መመገቢያ',
  subBeddingLinens: 'አንሶላና አልጋ ልብስ',
  subLighting: 'መብራት',
  subStorage: 'ማከማቻ',
  subSportsEquipment: 'የስፖርት መሣሪያዎች',
  subFitnessExercise: 'አካላዊ እንቅስቃሴ እና ስፖርት',
  subOutdoorCamping: 'ውጭና ካምፕ',
  subTeamSports: 'የቡድን ስፖርቶች',
  subCycling: 'ብስክሌት ግልቢያ',
  subAthleticWear: 'የአትሌቲክስ ልብስ',
  subBooksLiterature: 'መጻሕፍትና ሥነ ጽሑፍ',
  subStationeryJournals: 'የጽሕፈት ዕቃዎችና ማስታወሻ',
  subMusicFilm: 'ሙዚቃና ፊልም',
  subArtCollectibles: 'ጥበብና ቅርሶች',
  subMagazines: 'መጽሔቶች',
  subPhotography: 'ፎቶግራፍ',
  subDesignPrinting: 'ዲዛይንና ሕትመት',
  subRepairMaintenance: 'ጥገናና ጥገና አገልግሎት',
  subCleaning: 'ጽዳት',
  subPersonalCare: 'የግል እንክብካቤ',
  subClassesTraining: 'ትምህርቶችና ሥልጠና',
};